<!--师资培训菜单-->
<template>
    <div class="menu-container">
        <div @click="changeItem('1')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">个人资料</div>
        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">消息中心</div>
        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">任务中心</div>
<!--        <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">我的收藏</div>-->
<!--        <div @click="changeItem('5')" :class="activeItem==='5'?'menu-item menu-active':'menu-item'">我的关注</div>-->
        <div @click="changeItem('6')" :class="activeItem==='6'?'menu-item menu-active':'menu-item'">
            <div>教师档案</div>
            <div class="status-dtj" v-if="this.fillStatus === 0">
                待提交
            </div>
            <div class="status-dsh" v-if="this.fillStatus === 1&&(this.checkStatus === 0||this.checkStatus === 1)">待审核</div>
            <div class="status-ysh" v-if="this.fillStatus === 1&&this.checkStatus === 2">已审核</div>
            <div class="status-wtg" v-if="this.fillStatus === 1&&this.checkStatus === 3">未通过</div>
        </div>
        <div @click="changeItem('7')" :class="activeItem==='7'?'menu-item menu-active':'menu-item'">成长中心</div>
        <div @click="changeItem('8')" :class="activeItem==='8'?'menu-item menu-active':'menu-item'">课程收藏</div>
        <div @click="changeItem('9')" :class="activeItem==='9'?'menu-item menu-active':'menu-item'">我的关注</div>
    </div>

</template>

<script>

import {userCenterInfo} from "@/api/admin/public";

export default {
    name:'userCenterMenu',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {
        this.userInfo = JSON.parse(this.$storage.get("userInfo"))
        this.isCheckAuth = this.userInfo.isCheckAuth
        this.getUserCenterInfo();
        if (this.$store.state.params.jumpParams.activeItem){
            this.activeItem = this.$store.state.params.jumpParams.activeItem;
            this.showMode = "detail"
            this.$emit('change-mode',this.showMode);
        }
    },
    data() {
        return {
            activeItem:"1",
            fillStatus:0,//档案填报状态
            checkStatus: 0,//档案审核状态
            userInfo:{},
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.$emit('change-item', item );
        },
        getUserCenterInfo() {
            userCenterInfo().then(res => {
                this.checkStatus = res.data.data.checkStatus;
                this.fillStatus = res.data.data.fillStatus;
            })
        },
    }
}

</script>

<style scoped>
.menu-container{
    width: 100%;
    height: calc(100vh - 120px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;

}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
    display: flex;
}
.menu-active{
    background: #0d55a4;
    color: #fff;
    //font-weight: bold;
}
.status-dtj{
    width: 50px;
    background: #9E9E9E;
    color: #fff;
    text-align: center!important;
    text-indent: 0!important;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    margin-top: 15px;
    border-radius: 10px;
    margin-left: 20px;
}
.status-dsh{
    width: 50px;
    background: #FF9800;
    color: #fff;
    text-align: center!important;
    text-indent: 0!important;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    margin-top: 15px;
    border-radius: 10px;
    margin-left: 20px;
}
.status-ysh{
    width: 50px;
    background: #a2ef4d;
    color: #fff;
    text-align: center!important;
    text-indent: 0!important;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    margin-top: 15px;
    border-radius: 10px;
    margin-left: 20px;
}

.status-wtg{
    width: 60px;
    background: rgb(221, 11, 21);
    color: #fff;
    text-align: center!important;
    text-indent: 0!important;
    font-size: 12px;
    height: 24px;
    line-height: 24px;
    margin-top: 13px;
    border-radius: 10px;
    margin-left: 20px;
}
</style>